// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"2a15cf12","453":"a61c46b2","553":"4d5e316f"}[chunkId] + ".chunk.js";
};